<template>
  <div class="container-fluid variation-list">
    <div class="row">
      <div class="col-12">
        <br />
      </div>
    </div>
    <div
      class="row"
      @click="configure('stones')"
      v-if="
        currentItem.description &&
        currentItem.description.jewelleryType != '0' &&
        typeof currentItem.description.stones == 'object' &&
        currentItem.description.stones.diamondStock != false &&
        currentItem.description.stones.diamondStock.certificate != ''
      "
    >
      <div class="col-12">
        <div class="panel panel-default selected-stone">
          <div class="panel-heading stone-headline">
            {{ $t("Menu.list.diamondStock.selectedStone.title") }}
          </div>
          <div class="panel-body stone-body">
            {{ currentItem.description.stones.diamondStock.description }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-start">
        <StoneLibrary
          v-if="currentVarType == 'stones/library'"
          :possibleItems="possibleItems"
          :currentItem="currentItem"
          :ringLayout="ringLayout"
        ></StoneLibrary>
        <StoneGroup
          v-else-if="currentVarType.substr(0, 12) == 'stones/group'"
          :possibleItems="possibleItems"
          :currentItem="currentItem"
          :ringLayout="ringLayout"
        ></StoneGroup>
        <Stones
          v-else-if="currentVarType == 'stones'"
          :possibleItems="possibleItems"
          :currentItem="currentItem"
          :ringLayout="ringLayout"
        ></Stones>
        <Addons
          v-else-if="currentVarType == 'addons'"
          :possibleItems="possibleItems"
          :ringLayout="ringLayout"
        ></Addons>
        <Grooves
          v-else-if="currentVarType == 'grooves'"
          :possibleItems="possibleItems"
          :currentItem="currentItem"
          :ringLayout="ringLayout"
        ></Grooves>
        <Colors
          v-else-if="currentVarType == 'colors'"
          :possibleItems="possibleItems"
        ></Colors>
        <Metals
          v-else-if="currentVarType == 'metals'"
          :possibleItems="possibleItems"
        ></Metals>
        <Allocations
          v-else-if="currentVarType == 'allocations'"
          :possibleItems="possibleItems"
          :ringLayout="ringLayout"
        ></Allocations>
        <Finishes
          v-else-if="currentVarType == 'finishes'"
          :possibleItems="possibleItems"
        ></Finishes>
        <Profiles
          v-else-if="currentVarType == 'profiles'"
          :possibleItems="possibleItems"
          :ringLayout="ringLayout"
        ></Profiles>
        <Shutters
          v-else-if="currentVarType == 'shutters'"
          :possibleItems="possibleItems"
          :ringLayout="ringLayout"
        ></Shutters>
        <Widths
          v-else-if="currentVarType == 'widths'"
          :possibleItems="possibleItems"
          :ringLayout="ringLayout"
        ></Widths>
        <ChainWidths
          v-else-if="currentVarType == 'chainWidths'"
          :possibleItems="possibleItems"
          :ringLayout="ringLayout"
        ></ChainWidths>
        <Lengths
          v-else-if="currentVarType == 'lengths'"
          :possibleItems="possibleItems"
          :ringLayout="ringLayout"
        ></Lengths>
        <Necklace
          v-else-if="currentVarType == 'jewellery/necklace'"
          :possibleItems="possibleItems"
          :ringLayout="ringLayout"
        ></Necklace>
        <Engraving
          v-else-if="
            currentVarType == 'engraving' &&
            set.currentItem !== 'overview' &&
            set.currentItem !== 'all' &&
            set.currentItem !== 'set'
          "
          :possibleItems="possibleItems"
          :currentItem="currentItem"
          :ringLayout="ringLayout"
        ></Engraving>
        <JewelleryNormal
          v-else-if="currentVarType == 'stones/jewellery/normal'"
          :possibleItems="possibleItems"
          :currentItem="currentItem"
          :ringLayout="ringLayout"
        ></JewelleryNormal>
        <JewelleryModel
          v-else-if="currentVarType == 'stones/jewellery/model'"
          :possibleItems="possibleItems"
          :currentItem="currentItem"
          :ringLayout="ringLayout"
        ></JewelleryModel>
        <Standard
          v-else
          :possibleItems="possibleItems"
          :currentItem="currentItem"
          :ringLayout="ringLayout"
        ></Standard>
      </div>
    </div>
    <div class="row col-to-overview">
      <div class="col-12 text-center">
        <br />
        <button
          @click="backToItem()"
          class="btn btn-secondary btn-block"
          style="width: auto"
        >
          {{ $t("Menu.back.mobile") }}
        </button>
        <button
          @click="showItemDetails()"
          class="btn btn-secondary btn-block"
          style="width: auto"
        >
          {{ $t("Common.itemDetailsShow") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SetData from "@/vuex/SetData";
import StoneLibrary from "@/components/Forms/Variations/Stones/Library";
import StoneGroup from "@/components/Forms/Variations/Stones/Group";
import Stones from "@/components/Forms/Variations/Stones";
import Addons from "@/components/Forms/Variations/Addons";
import Grooves from "@/components/Forms/Variations/Grooves";
import Colors from "@/components/Forms/Variations/Colors";
import Metals from "@/components/Forms/Variations/Metals";
import Allocations from "@/components/Forms/Variations/Allocations";
import Finishes from "@/components/Forms/Variations/Finishes";
import Profiles from "@/components/Forms/Variations/Profiles";
import Shutters from "@/components/Forms/Variations/Shutters";
import Necklace from "@/components/Forms/Variations/Necklace";
import Widths from "@/components/Forms/Variations/Widths";
import ChainWidths from "@/components/Forms/Variations/ChainWidths";
import Lengths from "@/components/Forms/Variations/Lengths";
import Engraving from "@/components/Forms/Engraving";
import Standard from "@/components/Forms/Variations/Standard";
import JewelleryNormal from "@/components/Forms/Variations/Stones/Jewellery/Normal";
import JewelleryModel from "@/components/Forms/Variations/Stones/Jewellery/Model";
import Config from "@/vuex/Config";
import MediaQuery from "@/assets/Helper/MediaQuery";

export default {
  name: "Variations",
  components: {
    Colors,
    Finishes,
    Allocations,
    Profiles,
    Shutters,
    Addons,
    Grooves,
    Widths,
    ChainWidths,
    Lengths,
    Necklace,
    Stones,
    StoneGroup,
    StoneLibrary,
    Engraving,
    Metals,
    Standard,
    JewelleryNormal,
    JewelleryModel,
  },
  props: ["possibleItems", "currentVarType", "menuList"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      getApiHost: Config.getters.getApiHost,
      set: SetData.getters.getSet,
      ringLayout: SetData.getters.getRingLayout,
      currentItem: SetData.getters.getCurrentItem,
      currentItemId: SetData.getters.getCurrentItemId,
    };
  },
  updated() {
    this.currentItem = SetData.getters.getCurrentItem;
  },
  computed: {
    isDesktop() {
      return MediaQuery.isDesktop();
    },
    isAlloyCombi() {
      return this.$parent.$parent["isCurrentItemAlloyCombi"](
        SetData.getters.getCurrentItemId
      );
    },
  },
  methods: {
    scrollIntoView() {
      if (!MediaQuery.isDesktop()) {
        setTimeout(() => {
          document.querySelector(".image-col-right").scrollIntoView();
        }, 250);
      }
    },
    showItemDetails() {
      this.$root.$emit("showItemDetails");
      this.scrollIntoView();
    },
    changeItem: function (itemnumber) {
      this.$parent.changeItem(itemnumber);
    },
    configure: function (type) {
      this.$root.$emit("configure", type);
    },
    backToItem: function () {
      Config.dispatch("setVisualMode", "show").then(() => {
        this.$root.$emit("hideLoader3D");
      });

      this.scrollIntoView();
    },
    getFinishIcon: function (finish, color, itemnumber, retina) {
      finish = finish.toLowerCase();
      color = color.toLowerCase();

      let imageSrc = "";

      if (finish !== "" && color !== "" && this.isAlloyCombi !== true) {
        if (retina === true) {
          imageSrc =
            this.appUrl +
            "/img/assets/colors/" +
            finish +
            "_" +
            color +
            "@2x.jpg";
        } else {
          imageSrc =
            this.appUrl + "/img/assets/colors/" + finish + "_" + color + ".jpg";
        }
      } else {
        let size = retina === true ? "240" : "120";
        itemnumber = typeof itemnumber == "object" ? itemnumber[0] : itemnumber;

        imageSrc =
          this.getApiHost +
          "/v2/images/item/ffffff/" +
          size +
          "/" +
          size +
          "/" +
          itemnumber.toUpperCase() +
          ".jpg";
      }

      return imageSrc;
    },
    setIconNotAvailable: function (iconNode) {
      if (iconNode && iconNode[0]) {
        iconNode[0].src = this.appUrl + "/img/assets/not-available.jpg";
        iconNode[0].srcset = this.appUrl + "/img/assets/not-available.jpg";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  div.container-fluid.variation-list {
    padding: 0 0 4rem 0;
    font-size: 1.6rem;
    text-align: left;

    .selected-stone {
      margin: 0 0 1.5rem .75rem;
      cursor: pointer;
      background-color: #ffffff;

      .stone-headline {
        font-weight: bold;
      }

      @media (min-width: 992px) {
        width: 26.5rem;
      }

      @media (min-width: 1200px) {
        width: 32.5rem;
      }
    }

    .col-to-overview {
      margin-top: 2rem;

      @media (min-width: 1200px) {
        display: none;
      }
    }
  }
}
</style>
